import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Base, IBaseButtonProps } from './Base';
import { themed, ITheme } from '../../themer';
import { getCommonButtonStyles } from './common';
import { ButtonText } from './ButtonText';

export const StyledButton = styled(Base)<IBaseButtonProps, ITheme>`
	max-width: 100%;

	${({ inverted, invertedSecondary, secondary, textButton }) =>
		themed((theme) =>
			getCommonButtonStyles(
				secondary ? 'secondary' : textButton ? 'textButton' : 'primary',
				theme,
				inverted,
				invertedSecondary,
			),
		)}
`;

export interface IButtonProps extends IBaseButtonProps {
	children: ReactNode;
}

export function Button({ children, ...props }: IButtonProps) {
	return (
		<StyledButton {...props}>
			<ButtonText>{children}</ButtonText>
		</StyledButton>
	);
}
